import { Globalization } from '../../data/globalization';
import { DateLike } from './date-like';
import { DateTime } from './date-time';

/**
 * An representation of a range between 2 dates, defining a start and an end Date object.
 */
export class DateRange {
    public start: Date;
    public end: Date;

    constructor(startAt?: DateLike, endAt?: DateLike) {
        this.start = startAt ? new Date(startAt) : new Date();
        this.end = endAt ? new Date(endAt) : new Date();
    }

    public isEqualTo(dateRange: DateRange): boolean {
        if (MsftSme.isNullOrUndefined(dateRange) || MsftSme.isNullOrUndefined(dateRange.start) || MsftSme.isNullOrUndefined(dateRange.end)
        ) {
            return false;
        }

        return this === dateRange || (DateTime.isEqual(dateRange.start, this.start) && DateTime.isEqual(dateRange.end, this.end));
    }

    public isValid() {
        return this.start && this.end && this.start.getTime() && this.end.getTime();
    }

    public toString(): string {
        return `{0} - {1}`.format(this.start.toLocaleString(Globalization.localeId), this.end.toLocaleString(Globalization.localeId));
    }

}
